import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getHRLayout(_datapointsHR, showTitle = true, small = false) {
  const datapointsHR = orderByDate(_datapointsHR);

  let layout = {
    theme: "light2",
    title: {
      text: showTitle
        ? `Grafico ultime ${datapointsHR.length} misurazioni`
        : "",
    },
    legend: {
      verticalAlign: "top",
      horizontalAlign: "center",
      dockInsidePlotArea: false,
    },
    toolTip: {
      shared: true,
    },
    axisY: {
      minimum: 20,
      gridThickness: 0.6,
      maximum: 140,
      interval: 20,
    },
    axisX: {
      labelFontSize: small ? 10 : 16,
      labelMaxWidth: small ? 45 : 60,
      stripLines: [],
      gridThickness: 0,
      labelTextAlign: "center",
      labelFormatter: function (e) {
        return CanvasJSReact.CanvasJS.formatDate(e.label, "DD/MM YYYY HH:mm");
      },
    },
    data: [
      {
        name: "Freq. Cardiaca",
        type: "spline",
        showInLegend: true,
        legendMarkerType: "square",
        color: "#8e5948",
        lineColor: "#8e5948",
        dataPoints: datapointsHR.map((el) => {
          return {
            label: el.x,
            y: el.y,
          };
        }),
      },
    ],
  };
  return layout;
}

export function parseHRReports(measures) {
  let datapointsHR = [];

  // prendo le misurazioni di hr + data
  measures.forEach((report, index) => {
    if (report.data.HR !== null && report.data.HR !== undefined) {
      datapointsHR.push({
        x: report.data.Date,
        y: eval(report.data.HR),
      });
    }
  });

  return {
    datapointsHR: datapointsHR,
  };
}

export function generateHRChart(reports, small = false) {
  const { datapointsHR } = parseHRReports(reports);

  // genero il report
  const layout = getHRLayout(datapointsHR, false, small);

  return layout;
}
